<template>
<a-layout id="layout-container">
    <a-layout-sider class="layout-sider" v-model="collapsed" :class="operatorCustom.class">
        <div class="logo" @click="collapsed = !collapsed" :class="{'collapsed': collapsed}">
            <img v-if="collapsed" :src="operatorCustom.admin_logo_c" :style="operatorCustom.style_c"/>
            <img v-else           :src="operatorCustom.admin_logo"   :style="operatorCustom.style"  />
        </div>
        <a-menu theme="light" :defaultOpenKeys="openKeys" v-model="selectedKeys" mode="inline" :inlineCollapsed='collapsed' style="padding-bottom: 56px;">
            <template v-for="item of showList">
                <template v-if="item.visible">
                    <template v-if="item.is_leaf">
                        <a-menu-item :key="item.path" @click="handleLink(item.path)" >
                            <i class='icon' :class="item.meta.icon"/>
                            <span :class="{'collapsed-title': collapsed}">{{item.meta.title}}</span>
                        </a-menu-item>
                    </template>
                    <template v-else>
                        <a-sub-menu :key="item.path">
                            <template slot="title">
                                <i class='icon' :class="item.meta.icon"/>
                                <span v-show="!collapsed">{{item.meta.title}}</span>
                            </template>
                            <template v-for="i of item.children">
                                <a-menu-item :key="item.path + '/' + i.path" v-if="i.visible"
                                    @click="handleLink(item.path + '/' + i.path)">
                                    <span v-if="i.meta.oldTitle && $Util.isSerVer(0)">{{ i.meta.oldTitle }}</span>
                                    <span v-else>{{ i.meta.title }}</span>
                                    <span v-if="i.meta.badge === 'device_fault' && deviceFaultBadge > 0"
                                        class="menu-badge">{{ deviceFaultBadge > 99 ? '99+' : deviceFaultBadge }}</span>
                                </a-menu-item>
                            </template>
                        </a-sub-menu>
                    </template>
                </template>
            </template>
        </a-menu>
    </a-layout-sider>
    <a-layout class="layout-main" :class="{longer: collapsed}">
        <a-layout-header class="layout-header">
            <MyBreadcrumb class="breadcrumb"/>
            <UserCenter />
        </a-layout-header>
        <a-layout-content class="layout-content">
            <div class="main-content">
                <router-view></router-view>
                <a-back-top :visibilityHeight="300" />
            </div>
        </a-layout-content>
    </a-layout>
</a-layout>
</template>

<script>
import Core from '../../core';
import routes from '@/router/routes.js';
const IMG_URL_PREFIX = Core.Const.NET.IMG_URL_PREFIX
const APP_NAME = process.env.VUE_APP_APP_NAME

export default {
    components: {
        MyBreadcrumb: () => import('./components/MyBreadcrumb.vue'),
        UserCenter: () => import('./components/UserCenter.vue'),
    },
    data() {
        return {
            loginType: Core.Data.getLoginType(),
            accountType: Core.Data.getUser() ? Core.Data.getUser().type : '',
            collapsed: false,
            openKeys: [],
            selectedKeys: [],
            deviceFaultBadge: 0,
            deviceFaultBadgeTimer: null,
        };
    },
    computed: {
        showList() {
            // 菜单可见性统一在脚本中预计算，模板只消费 visible 布尔值
            const showList = Core.Util.deepCopy(routes)
                .map((item) => {
                    const meta = item.meta || {};
                    const is_leaf = meta.is_leaf || false;
                    const children = (item.children || []).map((i) => ({
                        ...i,
                        visible: this.shouldShowItem(i),
                    }));
                    // 非叶子节点（子菜单）若无任何可见子项，则整体不展示，避免渲染空菜单节点
                    const hasVisibleChild = is_leaf || children.some((i) => i.visible);
                    return {
                        ...item,
                        is_leaf,
                        visible: this.shouldShowItem(item) && hasVisibleChild,
                        children,
                    };
                })
                .filter((item) => item.visible);
            return showList
        },
        // 设备故障告警菜单（meta.badge 标记）当前登录是否可见，不可见时不轮询角标。
        // showList 已按 shouldShowItem 预过滤父级与子项可见性（与模板渲染条件一致），
        // 此处只需查找可见的 badge 子项，避免无权限用户（如 ADMIN）持续请求角标接口
        deviceFaultMenuVisible() {
            return this.showList.some(item =>
                !item.is_leaf && item.visible &&
                (item.children || []).some(i => i.visible && (i.meta || {}).badge === 'device_fault')
            );
        },
        operatorCustom() {
            let operatorCustom = Core.Data.getOperatorCustom() || {}
            // 打开信息展示定制开关
            let admin_logo = (operatorCustom.flag_admin && operatorCustom.admin_logo) ? IMG_URL_PREFIX + operatorCustom.admin_logo : ''
            switch (APP_NAME) {
                case 'QIANNIU':
                    return {
                        class: 'qianniu',
                        admin_logo:   admin_logo || require('@/assets/images/logo-pianniu.png'),
                        admin_logo_c: admin_logo || require('@/assets/images/logo-pianniu-c.png'),
                        style:   'height: 32px;',
                        style_c: 'height: 32px;',
                    }
                case 'AIMA':
                    return {
                        class: 'aiam',
                        admin_logo:   admin_logo || require('@/assets/images/logo-aima.png'),
                        admin_logo_c: admin_logo || require('@/assets/images/logo-aima-c.png'),
                        style:   'height: 14px;',
                        style_c: 'height:  9px;',
                    }
                default:
                    return {
                        class: 'custom',
                        admin_logo:   admin_logo || require('@/assets/images/logo-bolai.png'),
                        admin_logo_c: admin_logo || require('@/assets/images/logo-bolai.png'),
                        style:   'height: 22px;',
                        style_c: 'height: 16px;',
                    }
            }
        },
    },
    watch: {
        $route: {
            deep: true,
            immediate: true,
            handler(n) {
                // console.log('$route watch:', n)
                if (n.redirectedFrom) {
                    this.selectedKeys = [n.redirectedFrom]
                } else {
                    this.selectedKeys = [n.path]
                }
            }
        }
    },
    created() {
        for (const item of routes) {
            if (item.children) {
                for (const i of item.children) {
                    if (item.path + '/' + i.path === this.$route.path) {
                        this.openKeys = [item.path];
                        break;
                    }
                }
            }
        }
    },
    mounted() {
        this.startDeviceFaultBadgePolling();
    },
    beforeDestroy() {
        if (this.deviceFaultBadgeTimer) {
            clearInterval(this.deviceFaultBadgeTimer);
        }
    },
    methods: {
        handleLink(path) {
            this.$router.push(path);
        },
        // 侧边栏「设备故障告警」菜单角标：菜单可见时 30s 轮询（与 power-api 缓存 TTL 对齐）
        startDeviceFaultBadgePolling() {
            if (!this.deviceFaultMenuVisible) {
                return;
            }
            this.fetchDeviceFaultBadge();
            this.deviceFaultBadgeTimer = setInterval(() => this.fetchDeviceFaultBadge(), 30000);
        },
        async fetchDeviceFaultBadge() {
            try {
                const res = await Core.Api.DeviceFault.badge();
                this.deviceFaultBadge = res.badge || 0;
            } catch (e) {
                // 角标取数失败静默（0 不显示），不打扰当前操作
            }
        },
        /** 统一判断菜单项（含子项）是否展示
         *  整合 角色限制 / 隐藏状态 / 权限校验 / 反权限校验 / 服务版本控制
         * @param {Object} item 路由（菜单）配置项
         * @returns {Boolean}
         */
        shouldShowItem(item) {
            const meta = item.meta || {};
            const role_flag = meta.roles ? meta.roles.includes(this.loginType) : true;
            const account_auth_flag = meta.account_auth ? meta.account_auth.includes(this.accountType) : true;
            const hidden_flag = !meta.hidden;
            const auth_flag = this.$auth(...(meta.auth || []));
            const anti_auth_flag = this.getAntiAuth(item.anti_auth || meta.anti_auth || []);
            const service_version_flag = meta.service_version !== undefined ? Core.Util.isSerVer(meta.service_version) : true;

            return role_flag && account_auth_flag && hidden_flag && auth_flag && anti_auth_flag && service_version_flag;
        },
        getAntiAuth(antiAuths) {
            if (antiAuths.length && this.$auth(...antiAuths)) {
                // 有antiAuths 且 用户权限包含antiAuths -> 不予显示该菜单
                return false
            }
            return true // antiAuths为空  或  有antiAuths但用户权限未包含antiAuths
        }
    }
};
</script>

<style lang="scss">
#layout-container {
    background-color: $bg_layout;
    .layout-sider {
        overflow-y: auto;
        overflow-x: hidden;
        height: 100vh;
        position: fixed;
        left: 0;
        z-index: 1;
        background-color: $white;
        border-right: 1px solid $bc_layout;
        .logo {
            width: 100%;
            height: 50px;
            display: flex;
            align-items: center;
            overflow: hidden;
            img {
                max-width: calc(100% - 40px);
                margin-left: 20px;
            }
            &.collapsed {
                justify-content: center;
                img {
                    max-width: 100%;
                    margin-left: 0;
                }
            }
        }
        i.icon {
            margin-right: 10px;
            font-size: $fz_bs;
        }
        .collapsed-title {
            padding-left: 24px;
        }
        .ant-menu {
            height: calc(100% - 50px);
            overflow-y: auto;
            overflow-x: hidden;
            &.ant-menu-inline {
                border-right: 0;
            }
            .ant-menu-item {
                height: 40px;
                line-height: 40px;
                margin: 0;
                &:hover {
                    background: rgba($primary, 0.1);
                    opacity: 0.7;
                }
                &.ant-menu-item-selected {
                    color: $white;
                    background-color: $primary;
                    &::after {
                        display: none;
                    }
                }
            }
            // 「设备故障告警」菜单角标（0 不显示、>99 显示 99+）
            .menu-badge {
                float: right;
                margin: 12px 0 0 4px;
                padding: 0 5px;
                min-width: 16px;
                height: 16px;
                line-height: 16px;
                border-radius: 8px;
                background-color: $red;
                color: $white;
                font-size: 12px;
                text-align: center;
                box-sizing: border-box;
            }
            &.ant-menu-inline-collapsed {
                .menu-badge {
                    display: none;
                }
            }
            .ant-menu-submenu-title {
                height: 32px;
                line-height: 32px;
            }
            @include scrollbar(3px);
        }
        .ant-menu-inline .ant-menu-item,
        .ant-menu-inline .ant-menu-submenu-title {
            width: 100%;
            font-size: $fz_bs !important;
        }
        .ant-menu-submenu-selected,
        .ant-menu-item:hover,
        .ant-menu-item-active,
        .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
        .ant-menu-submenu-active,
        .ant-menu-submenu-title:hover {
            color: $primary;
        }
        .ant-menu-submenu-title:hover {
            .ant-menu-submenu-arrow::before,
            .ant-menu-submenu-arrow::after {
                background: $primary;
            }
        }
        &.aiam {
            .logo {
                background-color: $primary;
            }
            .ant-menu-submenu-selected,
            .ant-menu-item:hover,
            .ant-menu-item-active,
            .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
            .ant-menu-submenu-active,
            .ant-menu-submenu-title:hover {
                color: $primary;
            }
            .ant-menu {
                color: $side_tc_aima;
                .ant-menu-item {
                    &:hover {
                        background: rgba($side_active_bg, 0.5);
                    }
                    &.ant-menu-item-selected {
                        color: $black;
                        background-color: $side_active_bg;
                    }
                }
            }
            .ant-menu.ant-menu-root > .ant-menu-item.ant-menu-item-selected {
                color: $primary;
            }
        }
    }
    .layout-main {
        background-color: $bg_layout;
        height: 100vh;
        margin-left: 200px;
        width: calc(100% - 200px);
        .layout-header {
            height: 50px;
            width: calc(100% - 200px);
            background: $white;
            padding: 0 20px;
            border-bottom: 1px solid $bc_layout;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: fixed;
            z-index: 10;
            @media (max-width:768px) {
                .breadcrumb {
                    visibility: hidden;
                }
            }
        }
        .layout-content {
            padding: 66px 0 16px;
            height: calc(100% - 50px);
            overflow-y: auto;
            overflow-x: auto;
            @include scrollbar(10px);
            .main-content {
                padding: 0 16px;
                min-height: 100px;
                min-width: 500px;
            }
        }
        &.longer {
            margin-left: 80px;
            width: calc(100% - 80px);
            .layout-header {
                width: calc(100% - 80px);
            }
        }
    }
}
.ant-menu-inline-collapsed-tooltip {
    font-size: $fz_bs;
    i.icon {
        display: none;
    }
}
.ant-menu-vertical.ant-menu-sub > .ant-menu-item {
    width: 100%;
    font-size: $fz_bs !important;
    margin: 4px 0 !important;
    height: 32px;
    line-height: 32px;
}
</style>